import { THEMES } from "./definitions/definitions";

export const THEME_IDS = THEMES.map((t) => t.id);
